import { Info } from "lucide-react";

const WhatsAppButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Info Button */}
      <a
        href="/assest/IHCL Dubai Profile.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#FFA23A] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 ml-auto hover:bg-[#FFA23A]/90"
        aria-label="View Company Profile"
      >
        <Info className="w-6 h-6" />
      </a>
      
      {/* WhatsApp Button */}
      <a
        href="https://wa.link/qyr374"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:scale-110 transition-transform duration-300"
        aria-label="Chat on WhatsApp"
      >
        <img 
          src="/assest/icon/whatsapp.png" 
          alt="WhatsApp" 
          className="w-12 h-12" 
        />
      </a>
    </div>
  );
};

export default WhatsAppButton;

